// get a random int below a max
export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

// get a random bool
export const getRandomBool = () => {
  return Math.random() < 0.5;
};

// a vector from one point to another
export const vectorFromTo = (from, to) => {
  return { x: to.x - from.x, y: to.y - from.y };
};

// distance between two points
export const distance = (p1, p2) => {
  return vectorMagnitude(vectorFromTo(p1, p2));
};

// get random element from an array
export const getRandomElement = (arr) => {
  return arr[getRandomInt(arr.length)];
};

// normalize a vector
export const vectorNormalize = (v) => {
  const m = vectorMagnitude(v);
  return { x: v.x / m, y: v.y / m };
};

export const vectorDiv = (v, s) => {
  return { x: v.x / s, y: v.y / s };
};

export const vectorAdd = (v, ...vRest) => {
  const x = vRest.reduce((a, b) => {
    return a + b.x;
  }, v.x);
  const y = vRest.reduce((a, b) => {
    return a + b.y;
  }, v.y);
  return {
    x: x,
    y: y,
  };
};

export const vectorAvg = (v, ...vRest) => {
  const sum = vectorAdd(v, ...vRest);
  return vectorDiv(sum, vRest.length + 1);
};

export const getRandomNormal = () => {
  const x = Math.random() * 2 - 1;
  const y = Math.random() * 2 - 1;
  return vectorNormalize({ x: x, y: y });
};

// calculate the magnitude of a vector
export const vectorMagnitude = (v) => {
  return Math.sqrt(v.x * v.x + v.y * v.y);
};
